import React from 'react'
import type { Icon } from 'shared/utils'

const CircleInfo = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'circle-info',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M12 2h0C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h0c0-5.523-4.477-10-10-10h0z"
                    stroke={color}
                />
                <path
                    d="M12.833 17a.833.833 0 01-1.667 0v-5.833a.833.833 0 111.667 0V17zM12 8.667a1.25 1.25 0 111.25-1.25c0 .69-.56 1.25-1.25 1.25z"
                    fill={color}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}

export { CircleInfo }
